import { Translate } from 'next-translate';
import { TextProps } from '@chakra-ui/react';
import { CardOpportunityProps } from '../../interface/secondaries';
import { formatToPTBRDate } from '@/utils/date';
import { formatNumberToPTBRCurrency, formatToPercentage } from '@/utils/format';

export const getCustomPropsLabel = (isPositive: boolean) => {
  return {
    fontWeight: 'semibold',
    color: isPositive ? 'graph.green' : 'graph.red',
    sx: {
      svg: {
        ...getSvgProps(isPositive),
      },
    },
  };
};

const getSvgProps = (isPositive: boolean) => {
  return {
    mt: !isPositive ? 0 : '-5px',
    ml: !isPositive ? '2xs' : 'none',
    mr: !isPositive ? '-4px' : 0,
    transform: !isPositive ? 'rotate(180deg)' : 'none',
  };
};

type TypeInfos = {
  label: string;
  value: string | number | undefined;
  isPercentage?: boolean;
  customProps?: TextProps;
}[];

export const generateInfosLabelValue = (
  data: CardOpportunityProps,
  i18n: Translate
): TypeInfos => {
  if (data?.type === 'wallet') {
    return [
      {
        label: i18n(
          `screens.secondariesOpportunities.cardOpportunity.infosLabel.wallet.label01`
        ),
        value: data?.profile,
      },
      {
        label: i18n(
          `screens.secondariesOpportunities.cardOpportunity.infosLabel.wallet.label02`
        ),
        isPercentage: true,
        customProps: {
          ...getCustomPropsLabel((data?.return_last_year ?? 0) > 0),
        },
        value: formatToPercentage(data?.return_last_year ?? 0, 1),
      },
      {
        label: i18n(
          `screens.secondariesOpportunities.cardOpportunity.infosLabel.wallet.label03`
        ),
        isPercentage: true,
        customProps: {
          ...getCustomPropsLabel((data?.benchmark ?? 0) > 0),
        },
        value: formatToPercentage(data?.benchmark ?? 0, 1),
      },
    ];
  }

  return [
    {
      label: i18n(
        `screens.secondariesOpportunities.cardOpportunity.infosLabel.default.label01`
      ),
      value: formatNumberToPTBRCurrency(Number(data?.unit_price) ?? 0),
    },
    {
      label: i18n(
        `screens.secondariesOpportunities.cardOpportunity.infosLabel.default.label02`
      ),
      value: formatNumberToPTBRCurrency(Number(data?.unit_price) ?? 0),
    },
    {
      label: i18n(
        `screens.secondariesOpportunities.cardOpportunity.infosLabel.default.label03`
      ),
      value: formatToPTBRDate(data?.due_date),
    },
    {
      label: i18n(
        `screens.secondariesOpportunities.cardOpportunity.infosLabel.default.label04`
      ),
      // customProps: {
      //   ...getCustomPropsLabel((data?.expect_profit ?? 0) > 0),
      // },
      value: data?.yield ?? '--',
    },
  ];
};
